import { render, staticRenderFns } from "./electric.vue?vue&type=template&id=f7024e6a&"
import script from "./electric.vue?vue&type=script&lang=js&"
export * from "./electric.vue?vue&type=script&lang=js&"
import style0 from "./electric.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports